import React from "react";

import { MenuItem } from "@/custom-types/MenuItem";

import Verified from "@/components/Icons/verified.svg";
import Prop65Message from "@/components/Prop65Message";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const Description = ({ menuItem }: { menuItem: MenuItem }) => {
  const getCannabinoidDisplay = () => {
    if (!menuItem.thcContentLabel && !menuItem.cbdContentLabel) {
      return "";
    }

    let display = "- ";

    if (!menuItem.thcContentLabel) {
      display += `THC ${!menuItem.thcContentLabel}`;
    }

    if (menuItem.cbdContent !== null && menuItem.cbdUnit) {
      display += `, CBD ${menuItem.cbdContentLabel}`;
    }
    return display;
  };

  const descriptionText = menuItem.description
    ? menuItem.description
    : `${menuItem.name}, ${
        menuItem.productCategory || ""
      } ${getCannabinoidDisplay()}`;

  return (
    <section className="max-w-[700px]">
      <h2 className="mb-sm">About this product</h2>
      {menuItem.isBrandVerified && (
        <div className="py-3">
          <div className="flex">
            <span className="mr-xs text-sm font-bold">Brand verified</span>
            <Verified
              style={{ marginTop: "5px" }}
              width="14"
              height="14"
              className="text-verified"
            />
          </div>
          <span className="text-xs text-secondary">
            Product details verified by brand
          </span>
        </div>
      )}
      <p className="text-base break-word hyphens-auto whitespace-pre-line">
        {descriptionText}
      </p>
      <Prop65Message className="mt-lg" />
    </section>
  );
};

export default Description;
